import { MagnifyingGlassIcon } from '@phosphor-icons/react';
import { useRef } from 'react';

import classNames from '@utils/classnames';
import { controlClassName } from '../form/control';
import { SearchTypeSelect } from './SearchTypeSelect';

export interface SearchType {
  label: string;
  value: string;
}

export interface Props {
  value: string;
  onChange: (newValue: string) => void;
  types: SearchType[];
  selectedType: string;
  onTypeChange: (newType: string) => void;
  placeholder?: string;
}

/** Search input with a "search in …" type picker attached on the right. */
export const SearchWithType: React.FC<Props> = (props) => {
  const { value, onChange, types, selectedType, onTypeChange, placeholder } = props;
  const inputRef = useRef<null | HTMLInputElement>(null);

  return (
    <div className={classNames(controlClassName(), 'flex items-center overflow-hidden')}>
      <div className="flex shrink-0 items-center pl-2.5 pr-2 text-fg-muted">
        <MagnifyingGlassIcon className="input-icon" />
      </div>
      <input
        ref={inputRef}
        className="h-full min-w-0 flex-1 bg-transparent text-fg outline-hidden"
        type="text"
        onChange={(evt) => onChange(evt.target.value)}
        value={value}
        placeholder={placeholder}
        autoComplete="off"
      />
      <div className="h-full shrink-0">
        <SearchTypeSelect values={types} selectedValue={selectedType} onSelectValue={onTypeChange} />
      </div>
    </div>
  );
};
